var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('Header'),_c('div',{staticClass:"page-body wrap fix"},[_c('div',{staticClass:"l"},[_c('SideBar')],1),_c('div',{staticClass:"r"},[_c('router-view')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }